import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import magic from '../utils/util';
import Loan from 'loan';
import { useState } from 'react';
import { useEffect } from 'react';

const useStyles = makeStyles(() => ({
    wrapper: {
        width: '100%'
    },
    label: {
        color: 'rgb(0,0,160)',
        fontSize: '18px',
        fontWeight: '400'
    },
    sliderBox: {
        margin: '0 32px'
    },
    sliderBoxInner: {
        display: 'flex'
    },
    sliderBoxRight: {
        marginLeft: 'auto',
        order: 2
    }
}));


const CalculationText = props => {

    const [eirAlg, setEriAlg] = useState('sambla');

    useEffect(() => {
        let params = window.location.href;
        params = params.match(/eir=(\w+)/);
        if (params) {
            setEriAlg(params[1]);
        }
    }, [])



    const classes = useStyles();
    const months = props.pageType === 4 ? props.years : props.years * 12;
    const zeroCheckIntrest = Number(props.intrest) === 0 ? 0.00001 : props.intrest;

    let loan = new Loan({
        type: props.config.misc.mortgageType,
        pay_every: 'month',
        principal: Number(props.amount),
        interest_rate: Number(props.intrest === 0 ? 0.00001 : props.intrest / 100),
        invoice_fee: Number(props.config.misc.invoiceFee),
        initial_fee: Number(props.config.misc.initialFee),
        instalments: Number(months)
    });

    const calculatedCosts = magic({
        loansum: Number(props.amount), intrest: zeroCheckIntrest,
        loantimemonths: Number(months), servicefee: Number(props.config.misc.invoiceFee),
        opening: Number(props.config.misc.initialFee),
        buyNow: props.buyNow
    });


    let totalAmount = Number(calculatedCosts.totalCost.toFixed(0));

    if (props.pageType === 5) {
        totalAmount = props.amount + loan.getTotalCost();
    }

    if (props.buyNow) {
        totalAmount = Number(props.amount) + Number(props.config.misc.invoiceFee) + Number(props.config.misc.initialFee);
    }


    let EIR = (loan.getEffectiveInterestRate() * 100);

    if (isNaN(EIR)) {
        EIR = '-';
    }
    else if (Math.sign(EIR) === -1) {
        EIR = '-';
    } else {
        EIR = EIR.toFixed(2).replace('.', ',') + '%';
    }






    const getPopulatedText = () => {
        if (!props.toc) {
            return null;
        }

        let toc = '';
        Object.keys(props.toc.text).forEach(item => {
            switch (item) {
                case 'intrest':
                    toc += ' <strong>' + props.intrest.toString().replace('.', ',') + '% </strong>';
                    break;
                case 'total':
                    toc += ' <strong>' + Number(totalAmount.toFixed(0)).toLocaleString("sv-SE", props.sekFormat).replace(',00', '') + '</strong>';
                    break;
                case 'subTotal':
                    toc += ' <strong>' + Number(loan.getTotalCost().toFixed(0)).toLocaleString("sv-SE", props.sekFormat).replace(',00', '') + '</strong>';
                    break;
                case 'numberOfPayments':
                    toc += '<strong>' + Number(months) + '</strong>';
                    break;
                case 'effectiveInterestRate':
                    toc += '<strong>' + EIR + '</strong>'
                    break;
                case 'raw':
                    break;
                case 'invoiceFee':
                    toc += '<strong>' + Number(props.config.misc.invoiceFee) + '</strong>';
                    break;
                case 'initialFee':
                    toc += '<strong>' + Number(props.config.misc.initialFee) + '</strong>';
                    break;
                case 'amount':
                    toc += '<strong>' + Number(props.amount) + '</strong>';
                    break;
                case 'month':
                    toc += '<strong>' + (Number(loan.getPaymentPlan()[3].to_pay.toFixed(0)) + Number(props.config.misc.invoiceFee)) + '</strong>';
                    break;
                default:

                    toc += (props.toc.text[item] && props.toc.text[item].length) ? props.toc.text[item] : '';
                    break
            }

        })

        return toc;
    }

    return (<div className={classes.wrapper}>
        <div style={{ padding: '0 8.3%', margin: 0, fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: getPopulatedText() }} ></div>
    </div>)
}

export default CalculationText; 